import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const OMNI_EDGE_LOCATION_OFFBOARDING_SCRIPT_QUERY_KEY =
  'omni-edge-location-offboarding-script';

const getEdgeLocationOffboardingScriptQueryKey = (
  clusterId: string,
  edgeLocationId: string
) =>
  [
    OMNI_EDGE_LOCATION_OFFBOARDING_SCRIPT_QUERY_KEY,
    clusterId,
    edgeLocationId,
  ] as const;

const getEdgeLocationOffboardingScriptQueryOptions = ({
  clusterId,
  edgeLocationId,
  enabled,
  organizationId,
}: {
  clusterId: string;
  edgeLocationId: string;
  enabled: boolean;
  organizationId: string | undefined;
}) =>
  queryOptions({
    queryKey: getEdgeLocationOffboardingScriptQueryKey(
      clusterId,
      edgeLocationId
    ),
    queryFn: async () => {
      const { data } = await apiClient.omni.getEdgeLocationOffboardingScript({
        organizationId: organizationId!,
        clusterId,
        id: edgeLocationId,
      });

      return data.script;
    },
    enabled: enabled && !!clusterId && !!edgeLocationId && !!organizationId,
  });

export const useGetEdgeLocationOffboardingScriptQuery = ({
  clusterId,
  edgeLocationId,
  enabled = true,
}: {
  clusterId: string;
  edgeLocationId: string;
  enabled?: boolean;
}) => {
  const { currentOrganization } = useOrganizations();

  const {
    data: script,
    isLoading,
    error,
    refetch,
  } = useQuery(
    getEdgeLocationOffboardingScriptQueryOptions({
      clusterId,
      edgeLocationId,
      enabled,
      organizationId: currentOrganization?.id,
    })
  );

  return {
    script,
    isLoading,
    error,
    refetch,
  };
};
